import { MdOutlineWarningAmber, MdOutlinedFlag } from "react-icons/md";
import styled from "styled-components";
import { DAVYS_GREY_300, DAVYS_GREY_800, ERROR_RED_500 } from "./colors";
import FlexBox from "./FlexBox";
import { Body2 } from "./Headings";

const ErrorContainer = styled.div`
  width: 100%;
  min-width: 0;
  border: 1px solid #d9d9d9;
  border-radius: 16px;
  background: white;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  box-sizing: border-box;
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    width: 18px;
    height: 18px;
    color: ${ERROR_RED_500};
  }
`;

const ErrorDescription = styled(Body2)`
  min-width: 0;
  overflow-wrap: anywhere;
  word-break: break-word;
  white-space: pre-wrap;
`;

const SuggestionBox = styled(FlexBox)`
  background: ${DAVYS_GREY_300};
  border-radius: 8px;
  padding: 8px 12px;

  align-items: center;
  justify-content: space-between;
  gap: 16px;
  min-width: 0;
`;

const ReportButton = styled.button`
  display: inline-flex;
  align-items: center;
  column-gap: 0.375rem;
  border: none;
  border-radius: 0.375rem;
  background: white;
  color: ${DAVYS_GREY_800};
  font-size: 0.8125rem;
  line-height: 1.25rem;
  padding: 0.5rem;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;

  &:hover:not(:disabled) {
    border-color: transparent;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.7;
  }
`;

const MenuStatusText = styled(Body2)`
  white-space: nowrap;
  margin: 0 auto;
`;

const ErrorMessageReporting = ({
  title = "We couldn't generate a response.",
  errorDescription = "A response couldn't be generated due to an unexpected error.",
  suggestionText = "Try rephrasing your prompt. If the issue persists, reach out to support.",
  onReport,
  reportButtonText = "Report",
  message,
  messageId,
  isReported = false,
}) => {
  return (
    <ErrorContainer>
      <FlexBox column rowGap="8px">
        <FlexBox columnGap="8px">
          <IconWrapper>
            <MdOutlineWarningAmber />
          </IconWrapper>

          <Body2 bold>{title}</Body2>
        </FlexBox>

        <ErrorDescription>{errorDescription}</ErrorDescription>
      </FlexBox>

      <SuggestionBox>
        <ErrorDescription>{suggestionText}</ErrorDescription>
        {isReported ? (
          <MenuStatusText>Already reported</MenuStatusText>
        ) : (
          <ReportButton onClick={() => onReport(message, messageId)}>
            <MdOutlinedFlag size={16} />
            {reportButtonText}
          </ReportButton>
        )}
      </SuggestionBox>
    </ErrorContainer>
  );
};

export default ErrorMessageReporting;
